import { Formik } from 'formik';
import * as Yup from 'yup';
import { Box, Image, Textarea } from '@chakra-ui/react';
import { Button, Divider, FormControl, FormHelperText, InputLabel, MenuItem, OutlinedInput, Select, Typography } from '@mui/material';
import {
  IconAt,
  IconBulb,
  IconCake,
  IconCalendarCog,
  IconCheck,
  IconColorFilter,
  IconLock,
  IconPhone,
  IconPhoto,
  IconSignature,
  IconVideo
} from '@tabler/icons-react';
import DropzoneFormikInput from '../../utilities/Dropzone';
import React, { useEffect } from 'react';
import { toast } from 'react-toastify';
import { useAccounts } from '../../../hooks/Accounts/useAccounts';
import { useAuth } from '../../../hooks/Auth/useAuth';
import { UICheckbox } from '../../utilities/Input';
import UITypography from '../../utilities/Typography';
import { UIFormControlBox } from '../../utilities/Form';
// import { UIInputSelect } from '../../utilities/InputSelect';

const ProfileView = () => {
  const [loadingProfilePic, setLoadingProfilePic] = React.useState(false);
  const { onUpdateMineUser } = useAccounts();
  const { getMe } = useAuth();
  const [user, setUser] = React.useState(null);

  useEffect(() => {
    getMe().then((res) => {
      setUser(res);
    });
  }, []);

  const handleSubmit = async (values) => {
    const {
      name,
      surname,
      phone,
      email,
      password,
      profile_pic,
      age,
      sex,
      formation,
      about_me,
      professional_experience,
      publications,
      specializations,
      procedures,
      certifications,
      memberships,
      awards,
      insurance_agreements,
      years_experience,
      number_of_procedures,
      intro_video_url,
      instagram_link,
      doctor_specialization,
      pregnant,
      permanent_makeup,
      anamnesi,
      allergies,
      other_allergies,
      survey_enabled,
      email_new_appointment,
      email_confirmed_appointment,
      email_rejected_appointment,
      appointments_direct_delete,
      first_visit_active,
      // first_visit_days_before,
      // first_visit_duration,
      // max_first_visit_for_day,
      // max_first_visit_for_month,
      // max_first_visit_for_week,
      is_first_visit_free,
    } = values;

    onUpdateMineUser({
      user_data: {
        name,
        surname,
        phone,
        email,
        password,
        profile_pic,
        age,
        sex,
        pregnant,
        permanent_makeup,
        anamnesi,
        allergies,
        other_allergies,
        formation,
        about_me,
        professional_experience,
        publications,
        specializations,
        procedures,
        certifications,
        memberships,
        awards,
        insurance_agreements,
        years_experience,
        number_of_procedures,
        intro_video_url,
        instagram_link,
        doctor_specialization,
        survey_enabled,
        email_new_appointment,
        email_confirmed_appointment,
        email_rejected_appointment,
        appointments_direct_delete,
        first_visit_active,
        // first_visit_days_before: parseInt(first_visit_days_before),
        // first_visit_duration: parseInt(first_visit_duration),
        // max_first_visit_for_day: parseInt(max_first_visit_for_day),
        // max_first_visit_for_month: parseInt(max_first_visit_for_month),
        // max_first_visit_for_week: parseInt(max_first_visit_for_week),
        is_first_visit_free,
      }
    }).then((res) => {
      toast(res?.response, {
        style: {
          fontSize: '14px',
          backgroundColor: '#00e676',
          color: '#ffffff'
        }
      });
    });
  };

  return (
    <Box>
      <>
        <Formik
          initialValues={{
            name: user?.name ?? '',
            surname: user?.surname ?? '',
            phone: user?.phone ?? '',
            email: user?.email ?? '',
            password: '',
            profile_pic: user?.profile_pic ?? '',
            age: user?.age ?? '',
            sex: user?.sex ?? '',
            formation: user?.formation ?? '',
            about_me: user?.about_me ?? '',
            professional_experience: user?.professional_experience ?? '',
            publications: user?.publications ?? '',
            specializations: user?.specializations ?? '',
            procedures: user?.procedures ?? '',
            certifications: user?.certifications ?? '',
            memberships: user?.memberships ?? '',
            awards: user?.awards ?? '',
            insurance_agreements: user?.insurance_agreements ?? '',
            years_experience: user?.years_experience ?? '',
            number_of_procedures: user?.number_of_procedures ?? '',
            intro_video_url: user?.intro_video_url ?? '',
            doctor_specialization: user?.doctor_specialization ?? '',
            instagram_link: user?.instagram_link ?? '',
            survey_enabled: user?.survey_enabled ?? false,
            email_new_appointment: user?.email_new_appointment ?? false,
            email_confirmed_appointment: user?.email_confirmed_appointment ?? false,
            email_rejected_appointment: user?.email_rejected_appointment ?? false,
            appointments_direct_delete: user?.appointments_direct_delete ?? false,
            first_visit_active: user?.first_visit_active ?? false,
            // first_visit_days_before: user?.first_visit_days_before ?? 0,
            // first_visit_duration: user?.first_visit_duration ?? 15,
            // max_first_visit_for_day: user?.max_first_visit_for_day ?? 0,
            // max_first_visit_for_month: user?.max_first_visit_for_month ?? 0,
            // max_first_visit_for_week: user?.max_first_visit_for_week ?? 0
            is_first_visit_free: user?.is_first_visit_free ?? false
          }}
          validationSchema={Yup.object().shape({
            name: Yup.string().nullable(),
            surname: Yup.string().nullable(),
            email: Yup.string().required('La mail è obbligatoria'),
            phone: Yup.string().nullable(),
            profile_pic: Yup.string().nullable(),
            age: Yup.number().nullable(),
            sex: Yup.string().nullable(),
            formation: Yup.string().nullable(),
            about_me: Yup.string().nullable(),
            professional_experience: Yup.string().nullable(),
            publications: Yup.string().nullable(),
            specializations: Yup.string().nullable(),
            procedures: Yup.string().nullable(),
            certifications: Yup.string().nullable(),
            memberships: Yup.string().nullable(),
            awards: Yup.string().nullable(),
            insurance_agreements: Yup.string().nullable(),
            years_experience: Yup.number().nullable(),
            number_of_procedures: Yup.number().nullable(),
            doctor_specialization: Yup.string().nullable(),
            instagram_link: Yup.string().nullable(),
            survey_enabled: Yup.boolean().nullable(),
            email_new_appointment: Yup.boolean().nullable(),
            email_confirmed_appointment: Yup.boolean().nullable(),
            email_rejected_appointment: Yup.boolean().nullable(),
            first_visit_active: Yup.boolean(),
            // first_visit_days_before: Yup.number().when('first_visit_active', {
            //   is: true,
            //   then: Yup.number()
            //     .required('Il numero di giorni prima della prima visita è obbligatorio')
            //     .min(1, 'Deve essere un numero maggiore di 0')
            // }),
            // first_visit_duration: Yup.number().when('first_visit_active', {
            //   is: true,
            //   then: Yup.number().required('La duarata della prima visita è obbligatorio').min(15, 'Deve essere un numero maggiore di 15')
            // }),
            // max_first_visit_for_day: Yup.number().when('first_visit_active', {
            //   is: true,
            //   then: Yup.number()
            //     .required('Il numero massimo di visite al giorno è obbligatorio')
            //     .min(1, 'Deve essere un numero maggiore di 0')
            // }),
            // max_first_visit_for_week: Yup.number().when('first_visit_active', {
            //   is: true,
            //   then: Yup.number()
            //     .required('Il numero massimo di visite alla settimana è obbligatorio')
            //     .min(1, 'Deve essere un numero maggiore di 0')
            // }),
            // max_first_visit_for_month: Yup.number().when('first_visit_active', {
            //   is: true,
            //   then: Yup.number()
            //     .required('Il numero massimo di visite al mese è obbligatorio')
            //     .min(1, 'Deve essere un numero maggiore di 0')
            // })
            is_first_visit_free: Yup.boolean()
          })}
          onSubmit={(values, { setErrors }) => handleSubmit(values, setErrors)}
          enableReinitialize={true}
        >
          {({ errors, handleBlur, handleSubmit, touched, values, setFieldValue }) => (
            <form onSubmit={handleSubmit} id={'appointment-form'}>
              {user && (
                <Box
                  w={'100%'}
                  h={'100%'}
                  bg={'transparent'}
                  display={'flex'}
                  justifyContent={'center'}
                  alignItems={'center'}
                  pointerEvents={'none'}
                >
                  <Box
                    className={'container'}
                    w={'100%'}
                    h={'100%'}
                    bg={'white'}
                    pointerEvents={'all'}
                    position={'relative'}
                    overflow={'hidden'}
                  >
                    <Box className={'top_data'} h={'calc(100% - 50px)'} overflow={'auto'}>
                      <Typography id="modal-modal-title" variant="h4" mt={4} ml={1.5}>
                        Modifica Profilo
                      </Typography>
                      <Box display={'flex'} mt={5} bg={'rgba(200,200,200,0.2)'} p={'10px'} alignItems={'center'}>
                        <IconSignature stroke={1.5} size="1.3rem" />
                        <Box ml={10}>
                          <FormControl fullWidth error={Boolean(touched.name && errors.name)}>
                            <InputLabel htmlFor="input-name">Nome</InputLabel>
                            <OutlinedInput
                              id="input-name"
                              type="text"
                              value={values.name}
                              name="name"
                              onBlur={handleBlur}
                              onChange={() => setFieldValue('name', event.target.value)}
                              label="Nome"
                            />
                            {touched.name && errors.name && (
                              <FormHelperText error id="standard-weight-helper-text-email-login">
                                {errors.name}
                              </FormHelperText>
                            )}
                          </FormControl>
                        </Box>
                      </Box>
                      <Box display={'flex'} mt={5} bg={'rgba(200,200,200,0.2)'} p={'10px'} alignItems={'center'}>
                        <IconSignature stroke={1.5} size="1.3rem" />
                        <Box ml={10}>
                          <FormControl fullWidth error={Boolean(touched.surname && errors.surname)}>
                            <InputLabel htmlFor="input-surname">Cognome</InputLabel>
                            <OutlinedInput
                              id="input-surname"
                              type="text"
                              value={values.surname}
                              name="surname"
                              onBlur={handleBlur}
                              onChange={() => setFieldValue('surname', event.target.value)}
                              label="Cognome"
                            />
                            {touched.surname && errors.surname && (
                              <FormHelperText error id="standard-weight-helper-text-email-login">
                                {errors.surname}
                              </FormHelperText>
                            )}
                          </FormControl>
                        </Box>
                      </Box>
                      <Box display={'flex'} mt={5} bg={'rgba(200,200,200,0.2)'} p={'10px'} alignItems={'center'}>
                        <IconPhone stroke={1.5} size="1.3rem" />
                        <Box ml={10}>
                          <FormControl fullWidth error={Boolean(touched.phone && errors.phone)}>
                            <InputLabel htmlFor="input-phone">Cellulare</InputLabel>
                            <OutlinedInput
                              id="input-phone"
                              type="text"
                              value={values.phone}
                              name="phone"
                              onBlur={handleBlur}
                              onChange={() => setFieldValue('phone', event.target.value)}
                              label="Cellulare"
                            />
                            {touched.phone && errors.phone && (
                              <FormHelperText error id="standard-weight-helper-text-email-login">
                                {errors.phone}
                              </FormHelperText>
                            )}
                          </FormControl>
                        </Box>
                      </Box>
                      <Box display={'flex'} mt={5} bg={'rgba(200,200,200,0.2)'} p={'10px'} alignItems={'center'}>
                        <IconAt stroke={1.5} size="1.3rem" />
                        <Box ml={10}>
                          <FormControl fullWidth error={Boolean(touched.email && errors.email)}>
                            <InputLabel htmlFor="input-surname">Email</InputLabel>
                            <OutlinedInput
                              id="input-email"
                              type="text"
                              value={values.email}
                              name="email"
                              onBlur={handleBlur}
                              onChange={() => setFieldValue('email', event.target.value)}
                              label="Email"
                            />
                            {touched.email && errors.email && (
                              <FormHelperText error id="standard-weight-helper-text-email-login">
                                {errors.email}
                              </FormHelperText>
                            )}
                          </FormControl>
                        </Box>
                      </Box>
                      <Box display={'flex'} mt={5} bg={'rgba(200,200,200,0.2)'} p={'10px'} alignItems={'center'}>
                        <IconLock stroke={1.5} size="1.3rem" />
                        <Box ml={10}>
                          <FormControl fullWidth error={Boolean(touched.password && errors.password)}>
                            <InputLabel htmlFor="input-surname">Password</InputLabel>
                            <OutlinedInput
                              id="input-password"
                              type="password"
                              value={values.password}
                              name="password"
                              onBlur={handleBlur}
                              onChange={() => setFieldValue('password', event.target.value)}
                              label="password"
                            />
                            <Typography variant={'caption'}>Lascia vuoto per non modificare</Typography>

                            {touched.password && errors.password && (
                              <FormHelperText error id="standard-weight-helper-text-password-login">
                                {errors.password}
                              </FormHelperText>
                            )}
                          </FormControl>
                        </Box>
                      </Box>
                      <Box display={'flex'} mt={5} bg={'rgba(200,200,200,0.2)'} p={'10px'} alignItems={'center'}>
                        <IconPhoto stroke={1.5} size="1.3rem" />
                        <Box ml={10} w={'85%'}>
                          <FormControl fullWidth error={Boolean(touched.profile_pic && errors.profile_pic)} w={'100%'}>
                            {loadingProfilePic && <>Loading</>}
                            <Typography id="modal-modal-description" variant="body1" fontWeight={'bold'} mb={1} ml={1}>
                              Immagine profilo
                            </Typography>
                            <Box display={'flex'} justifyContent={'space-between'} alignItems={'center'} p={'0 10px'}>
                              <Image src={values.profile_pic} w={'100px'} h={'100px'} objectFit={'cover'} />
                              <DropzoneFormikInput
                                variant={'profile_pic'}
                                setFieldValue={setFieldValue}
                                field={'profile_pic'}
                                setLoading={setLoadingProfilePic}
                                folder={'profile_pic'}
                                label={'Carica'}
                                extra_data={{
                                  account_uuid: user?.uuid
                                }}
                              />
                            </Box>
                          </FormControl>
                        </Box>
                      </Box>

                      <Box display={'flex'} mt={5} bg={'rgba(200,200,200,0.2)'} p={'10px'} alignItems={'center'}>
                        <IconCake stroke={1.5} size="1.3rem" />
                        <Box ml={10}>
                          <FormControl fullWidth error={Boolean(touched.age && errors.age)}>
                            <InputLabel htmlFor="input-age">Età</InputLabel>
                            <OutlinedInput
                              id="input-age"
                              type="number"
                              value={values.age}
                              name="age"
                              onBlur={handleBlur}
                              onChange={() => setFieldValue('age', event.target.value)}
                              label="Età"
                            />
                            {touched.age && errors.age && (
                              <FormHelperText error id="standard-weight-helper-text-email-login">
                                {errors.age}
                              </FormHelperText>
                            )}
                          </FormControl>
                        </Box>
                      </Box>
                      <Box display={'flex'} mt={5} bg={'rgba(200,200,200,0.2)'} p={'10px'} alignItems={'center'} w={'100%'}>
                        <IconColorFilter stroke={1.5} size="1.3rem" />
                        <Box ml={10} w={'85%'}>
                          <FormControl fullWidth error={Boolean(touched.sex && errors.sex)}>
                            <InputLabel id="sex-label">Sesso</InputLabel>
                            <Select
                              name={'sex'}
                              fullWidth={true}
                              value={values?.sex}
                              label="Sesso"
                              labelId="sex-label"
                              onChange={(e) => {
                                setFieldValue('sex', e.target.value);
                              }}
                              onBlur={handleBlur}
                              autoWidth
                            >
                              <MenuItem value={'M'}>Uomo</MenuItem>
                              <MenuItem value={'F'}>Donna</MenuItem>
                              <MenuItem value={'Other'}>Altro</MenuItem>
                            </Select>
                            {touched.color_id && errors.color_id && (
                              <FormHelperText error id="standard-weight-helper-text-email-login">
                                {errors.color_id}
                              </FormHelperText>
                            )}
                          </FormControl>
                        </Box>
                      </Box>
                      <Box display={'flex'} mt={5} bg={'rgba(200,200,200,0.2)'} p={'10px'} alignItems={'center'}>
                        <IconSignature stroke={1.5} size="1.3rem" />
                        <Box ml={10}>
                          <FormControl fullWidth error={Boolean(touched.doctor_specialization && errors.doctor_specialization)}>
                            <InputLabel htmlFor="input-doctor_specialization">Specializzazione</InputLabel>
                            <OutlinedInput
                              id="input-doctor_specialization"
                              type="text"
                              value={values.doctor_specialization}
                              name="doctor_specialization"
                              onBlur={handleBlur}
                              onChange={() => setFieldValue('doctor_specialization', event.target.value)}
                              label="Specializzazione"
                              inputProps={{
                                maxLength: 45
                              }}
                            />
                            {touched.doctor_specialization && errors.doctor_specialization && (
                              <FormHelperText error id="standard-weight-helper-text-email-login">
                                {errors.doctor_specialization}
                              </FormHelperText>
                            )}
                          </FormControl>
                        </Box>
                      </Box>
                      <Box display={'flex'} mt={5} bg={'rgba(200,200,200,0.2)'} p={'10px'} alignItems={'center'}>
                        <IconSignature stroke={1.5} size="1.3rem" />
                        <Box ml={10}>
                          <FormControl fullWidth error={Boolean(touched.instagram_link && errors.instagram_link)}>
                            <InputLabel htmlFor="input-instagram_link">Link instagram</InputLabel>
                            <OutlinedInput
                              id="input-instagram_link"
                              type="text"
                              value={values.instagram_link}
                              name="instagram_link"
                              onBlur={handleBlur}
                              onChange={() => setFieldValue('instagram_link', event.target.value)}
                              label="Link Instagram"
                            />
                            {touched.instagram_link && errors.instagram_link && (
                              <FormHelperText error id="standard-weight-helper-text-email-login">
                                {errors.instagram_link}
                              </FormHelperText>
                            )}
                          </FormControl>
                        </Box>
                      </Box>
                      {user?.doctor && (
                        <>
                          <Box display={'flex'} mt={5} bg={'rgba(200,200,200,0.2)'} p={'10px'} alignItems={'center'}>
                            <IconSignature stroke={1.5} size="1.3rem" />
                            <Box ml={10} w={'85%'}>
                              <FormControl fullWidth error={Boolean(touched.formation && errors.formation)} w={'100%'}>
                                <Typography id="modal-formation" variant="body1" fontWeight={'bold'}>
                                  Formazione
                                </Typography>
                                <Textarea
                                  id="input-formation"
                                  value={values.formation}
                                  name="name"
                                  onBlur={handleBlur}
                                  onChange={() => setFieldValue('formation', event.target.value)}
                                  label="Formazione"
                                  color={'#121926'}
                                  bg={'#f8fafc'}
                                  borderRadius={'12px'}
                                  placeholder={'Formazione'}
                                  p={'10px'}
                                  w={'100%'}
                                  minH={'100px'}
                                  resize={'none'}
                                  border={errors?.formation ? '1px solid red' : null}
                                />
                                {touched.formation && errors.formation && (
                                  <FormHelperText error id="standard-weight-helper-text-email-login">
                                    {errors.formation}
                                  </FormHelperText>
                                )}
                              </FormControl>
                            </Box>
                          </Box>
                          <Box display={'flex'} mt={5} bg={'rgba(200,200,200,0.2)'} p={'10px'} alignItems={'center'}>
                            <IconSignature stroke={1.5} size="1.3rem" />
                            <Box ml={10} w={'85%'}>
                              <FormControl fullWidth error={Boolean(touched.about_me && errors.about_me)} w={'100%'}>
                                <Typography id="modal-about_me" variant="body1" fontWeight={'bold'}>
                                  Su di me
                                </Typography>
                                <Textarea
                                  id="input-about_me"
                                  value={values.about_me}
                                  name="about_me"
                                  onBlur={handleBlur}
                                  onChange={() => setFieldValue('about_me', event.target.value)}
                                  label="Su di me"
                                  color={'#121926'}
                                  bg={'#f8fafc'}
                                  borderRadius={'12px'}
                                  placeholder={'Su di me'}
                                  p={'10px'}
                                  w={'100%'}
                                  minH={'100px'}
                                  resize={'none'}
                                  border={errors?.about_me ? '1px solid red' : null}
                                />
                                {touched.about_me && errors.about_me && (
                                  <FormHelperText error id="standard-weight-helper-text-email-login">
                                    {errors.about_me}
                                  </FormHelperText>
                                )}
                              </FormControl>
                            </Box>
                          </Box>
                          <Box display={'flex'} mt={5} bg={'rgba(200,200,200,0.2)'} p={'10px'} alignItems={'center'}>
                            <IconSignature stroke={1.5} size="1.3rem" />
                            <Box ml={10} w={'85%'}>
                              <FormControl
                                fullWidth
                                error={Boolean(touched.professional_experience && errors.professional_experience)}
                                w={'100%'}
                              >
                                <Typography id="modal-professional_experience" variant="body1" fontWeight={'bold'}>
                                  Esperienza professionale
                                </Typography>
                                <Textarea
                                  id="input-professional_experience"
                                  value={values.professional_experience}
                                  name="professional_experience"
                                  onBlur={handleBlur}
                                  onChange={() => setFieldValue('professional_experience', event.target.value)}
                                  label="Esperienza professionale"
                                  color={'#121926'}
                                  bg={'#f8fafc'}
                                  borderRadius={'12px'}
                                  placeholder={'Esperienza professionale'}
                                  p={'10px'}
                                  w={'100%'}
                                  minH={'100px'}
                                  resize={'none'}
                                  border={errors?.professional_experience ? '1px solid red' : null}
                                />
                                {touched.professional_experience && errors.professional_experience && (
                                  <FormHelperText error id="standard-weight-helper-text-email-login">
                                    {errors.professional_experience}
                                  </FormHelperText>
                                )}
                              </FormControl>
                            </Box>
                          </Box>
                          <Box display={'flex'} mt={5} bg={'rgba(200,200,200,0.2)'} p={'10px'} alignItems={'center'}>
                            <IconSignature stroke={1.5} size="1.3rem" />
                            <Box ml={10} w={'85%'}>
                              <FormControl fullWidth error={Boolean(touched.publications && errors.publications)} w={'100%'}>
                                <Typography id="modal-publications" variant="body1" fontWeight={'bold'}>
                                  Pubblicazioni
                                </Typography>
                                <Textarea
                                  id="input-publications"
                                  value={values.publications}
                                  name="publications"
                                  onBlur={handleBlur}
                                  onChange={() => setFieldValue('publications', event.target.value)}
                                  label="Pubblicazioni"
                                  color={'#121926'}
                                  bg={'#f8fafc'}
                                  borderRadius={'12px'}
                                  placeholder={'Pubblicazioni'}
                                  p={'10px'}
                                  w={'100%'}
                                  minH={'100px'}
                                  resize={'none'}
                                  border={errors?.publications ? '1px solid red' : null}
                                />
                                {touched.publications && errors.publications && (
                                  <FormHelperText error id="standard-weight-helper-text-email-login">
                                    {errors.publications}
                                  </FormHelperText>
                                )}
                              </FormControl>
                            </Box>
                          </Box>
                          <Box display={'flex'} mt={5} bg={'rgba(200,200,200,0.2)'} p={'10px'} alignItems={'center'}>
                            <IconSignature stroke={1.5} size="1.3rem" />
                            <Box ml={10} w={'85%'}>
                              <FormControl fullWidth error={Boolean(touched.specializations && errors.specializations)} w={'100%'}>
                                <Typography id="modal-specializations" variant="body1" fontWeight={'bold'}>
                                  Specializzazioni
                                </Typography>
                                <Textarea
                                  id="input-specializations"
                                  value={values.specializations}
                                  name="specializations"
                                  onBlur={handleBlur}
                                  onChange={() => setFieldValue('specializations', event.target.value)}
                                  label="Specializzazioni"
                                  color={'#121926'}
                                  bg={'#f8fafc'}
                                  borderRadius={'12px'}
                                  placeholder={'Specializzazioni'}
                                  p={'10px'}
                                  w={'100%'}
                                  minH={'100px'}
                                  resize={'none'}
                                  border={errors?.specializations ? '1px solid red' : null}
                                />
                                {touched.specializations && errors.specializations && (
                                  <FormHelperText error id="standard-weight-helper-text-email-login">
                                    {errors.specializations}
                                  </FormHelperText>
                                )}
                              </FormControl>
                            </Box>
                          </Box>
                          <Box display={'flex'} mt={5} bg={'rgba(200,200,200,0.2)'} p={'10px'} alignItems={'center'}>
                            <IconSignature stroke={1.5} size="1.3rem" />
                            <Box ml={10} w={'85%'}>
                              <FormControl fullWidth error={Boolean(touched.procedures && errors.procedures)} w={'100%'}>
                                <Typography id="modal-procedures" variant="body1" fontWeight={'bold'}>
                                  Procedure
                                </Typography>
                                <Textarea
                                  id="input-procedures"
                                  value={values.procedures}
                                  name="procedures"
                                  onBlur={handleBlur}
                                  onChange={() => setFieldValue('procedures', event.target.value)}
                                  label="Procedure"
                                  color={'#121926'}
                                  bg={'#f8fafc'}
                                  borderRadius={'12px'}
                                  placeholder={'Procedure'}
                                  p={'10px'}
                                  w={'100%'}
                                  minH={'100px'}
                                  resize={'none'}
                                  border={errors?.procedures ? '1px solid red' : null}
                                />
                                {touched.procedures && errors.procedures && (
                                  <FormHelperText error id="standard-weight-helper-text-email-login">
                                    {errors.procedures}
                                  </FormHelperText>
                                )}
                              </FormControl>
                            </Box>
                          </Box>
                          <Box display={'flex'} mt={5} bg={'rgba(200,200,200,0.2)'} p={'10px'} alignItems={'center'}>
                            <IconSignature stroke={1.5} size="1.3rem" />
                            <Box ml={10} w={'85%'}>
                              <FormControl fullWidth error={Boolean(touched.certifications && errors.certifications)} w={'100%'}>
                                <Typography id="modal-certifications" variant="body1" fontWeight={'bold'}>
                                  Certificazioni
                                </Typography>
                                <Textarea
                                  id="input-certifications"
                                  value={values.certifications}
                                  name="certifications"
                                  onBlur={handleBlur}
                                  onChange={() => setFieldValue('certifications', event.target.value)}
                                  label="Certificazioni"
                                  color={'#121926'}
                                  bg={'#f8fafc'}
                                  borderRadius={'12px'}
                                  placeholder={'Certificazioni'}
                                  p={'10px'}
                                  w={'100%'}
                                  minH={'100px'}
                                  resize={'none'}
                                  border={errors?.certifications ? '1px solid red' : null}
                                />
                                {touched.certifications && errors.certifications && (
                                  <FormHelperText error id="standard-weight-helper-text-email-login">
                                    {errors.certifications}
                                  </FormHelperText>
                                )}
                              </FormControl>
                            </Box>
                          </Box>
                          <Box display={'flex'} mt={5} bg={'rgba(200,200,200,0.2)'} p={'10px'} alignItems={'center'}>
                            <IconSignature stroke={1.5} size="1.3rem" />
                            <Box ml={10} w={'85%'}>
                              <FormControl fullWidth error={Boolean(touched.awards && errors.awards)} w={'100%'}>
                                <Typography id="modal-awards" variant="body1" fontWeight={'bold'}>
                                  Premi e riconoscimenti
                                </Typography>
                                <Textarea
                                  id="input-awards"
                                  value={values.awards}
                                  name="awards"
                                  onBlur={handleBlur}
                                  onChange={() => setFieldValue('awards', event.target.value)}
                                  label="Premi e riconoscimenti"
                                  color={'#121926'}
                                  bg={'#f8fafc'}
                                  borderRadius={'12px'}
                                  placeholder={'Premi e riconoscimenti'}
                                  p={'10px'}
                                  w={'100%'}
                                  minH={'100px'}
                                  resize={'none'}
                                  border={errors?.awards ? '1px solid red' : null}
                                />
                                {touched.awards && errors.awards && (
                                  <FormHelperText error id="standard-weight-helper-text-email-login">
                                    {errors.awards}
                                  </FormHelperText>
                                )}
                              </FormControl>
                            </Box>
                          </Box>
                          <Box display={'flex'} mt={5} bg={'rgba(200,200,200,0.2)'} p={'10px'} alignItems={'center'}>
                            <IconSignature stroke={1.5} size="1.3rem" />
                            <Box ml={10} w={'85%'}>
                              <FormControl
                                fullWidth
                                error={Boolean(touched.insurance_agreements && errors.insurance_agreements)}
                                w={'100%'}
                              >
                                <Typography id="modal-insurance_agreements" variant="body1" fontWeight={'bold'}>
                                  Convenzioni assicurative
                                </Typography>
                                <Textarea
                                  id="input-insurance_agreements"
                                  value={values.insurance_agreements}
                                  name="insurance_agreements"
                                  onBlur={handleBlur}
                                  onChange={() => setFieldValue('insurance_agreements', event.target.value)}
                                  label="Convenzioni assicurative"
                                  color={'#121926'}
                                  bg={'#f8fafc'}
                                  borderRadius={'12px'}
                                  placeholder={'Convenzioni assicurative'}
                                  p={'10px'}
                                  w={'100%'}
                                  minH={'100px'}
                                  resize={'none'}
                                  border={errors?.insurance_agreements ? '1px solid red' : null}
                                />
                                {touched.insurance_agreements && errors.insurance_agreements && (
                                  <FormHelperText error id="standard-weight-helper-text-email-login">
                                    {errors.insurance_agreements}
                                  </FormHelperText>
                                )}
                              </FormControl>
                            </Box>
                          </Box>
                          <Box display={'flex'} mt={5} bg={'rgba(200,200,200,0.2)'} p={'10px'} alignItems={'center'}>
                            <IconSignature stroke={1.5} size="1.3rem" />
                            <Box ml={10}>
                              <FormControl fullWidth error={Boolean(touched.years_experience && errors.years_experience)} w={'100%'}>
                                <InputLabel htmlFor="input-years_experience">Anni di esperienza</InputLabel>
                                <OutlinedInput
                                  id="input-years_experience"
                                  type="number"
                                  value={values.years_experience}
                                  name="years_experience"
                                  onBlur={handleBlur}
                                  onChange={() => setFieldValue('years_experience', event.target.value)}
                                  label="Anni di esperienza"
                                />
                              </FormControl>
                              {touched.years_experience && errors.years_experience && (
                                <FormHelperText error id="standard-weight-helper-text-email-login">
                                  {errors.years_experience}
                                </FormHelperText>
                              )}
                            </Box>
                          </Box>
                          {/*intro_video_url*/}
                          <Box display={'flex'} mt={5} bg={'rgba(200,200,200,0.2)'} p={'10px'} alignItems={'center'}>
                            <IconVideo stroke={1.5} size="1.3rem" />
                            <Box ml={10}>
                              <FormControl fullWidth error={Boolean(touched.intro_video_url && errors.intro_video_url)} w={'100%'}>
                                <InputLabel htmlFor="input-intro_video_url">Video di presentazione</InputLabel>
                                <OutlinedInput
                                  id="input-intro_video_url"
                                  type="text"
                                  value={values.intro_video_url}
                                  name="intro_video_url"
                                  onBlur={handleBlur}
                                  onChange={() => setFieldValue('intro_video_url', event.target.value)}
                                  label="Video di presentazione"
                                />
                                {touched.intro_video_url && errors.intro_video_url && (
                                  <FormHelperText error id="standard-weight-helper-text-email-login">
                                    {errors.intro_video_url}
                                  </FormHelperText>
                                )}
                              </FormControl>
                            </Box>
                          </Box>
                        </>
                      )}
                      <Box display={'flex'} mt={5} bg={'rgba(200,200,200,0.2)'} p={'10px'} alignItems={'center'}>
                        <IconBulb stroke={1.5} size="1.3rem" />
                        <Box ml={10}>
                          <UIFormControlBox>
                            <UICheckbox
                              label={<UITypography variant={'Oxygen700'} title={'Fornisci protocolli personalizzati'} size={'12px'} />}
                              checked={values?.survey_enabled}
                              onChange={(event) => setFieldValue('survey_enabled', event.target.checked)}
                            />
                          </UIFormControlBox>

                          <UIFormControlBox>
                            <UICheckbox
                              label={
                                <UITypography
                                  variant={'Oxygen700'}
                                  title={'Ricevi email e notifica quando un paziente prende un nuovo appuntamento'}
                                  size={'12px'}
                                />
                              }
                              checked={values?.email_new_appointment}
                              onChange={(event) => setFieldValue('email_new_appointment', event.target.checked)}
                            />
                          </UIFormControlBox>

                          <UIFormControlBox>
                            <UICheckbox
                              label={
                                <UITypography
                                  variant={'Oxygen700'}
                                  title={'Ricevi email e notifica quando un paziente conferma un appuntamento'}
                                  size={'12px'}
                                />
                              }
                              checked={values?.email_confirmed_appointment}
                              onChange={(event) => setFieldValue('email_confirmed_appointment', event.target.checked)}
                            />
                          </UIFormControlBox>

                          <UIFormControlBox>
                            <UICheckbox
                              label={
                                <UITypography
                                  variant={'Oxygen700'}
                                  title={'Ricevi email e notifica quando un paziente rifiuta un appuntamento'}
                                  size={'12px'}
                                />
                              }
                              checked={values?.email_rejected_appointment}
                              onChange={(event) => setFieldValue('email_rejected_appointment', event.target.checked)}
                            />
                          </UIFormControlBox>
                        </Box>
                      </Box>
                      <Box display={'flex'} mt={5} bg={'rgba(200,200,200,0.2)'} p={'10px'} alignItems={'center'}>
                        <IconCalendarCog stroke={1.5} size="1.3rem" />
                        <Box ml={10}>
                          <UIFormControlBox>
                            <UICheckbox
                              label={
                                <UITypography
                                  variant={'Oxygen700'}
                                  title={"Eliminazione diretta appuntamenti a cancellazione dell'utente"}
                                  size={'12px'}
                                />
                              }
                              checked={values?.appointments_direct_delete}
                              onChange={(event) => setFieldValue('appointments_direct_delete', event.target.checked)}
                            />
                          </UIFormControlBox>
                        </Box>
                      </Box>

                      {user.doctor && (
                        <>
                          <Box display={'flex'} mt={5} bg={'white'} p={'10px'} alignItems={'center'}>
                            <UITypography variant={'Oxygen700'} title={'Prima visita'} size={'16px'} />
                          </Box>
                          <Box display={'flex'} mt={5} bg={'rgba(200,200,200,0.2)'} p={'10px'} alignItems={'center'}>
                            <IconCalendarCog stroke={1.5} size="1.3rem" />
                            <Box ml={10}>
                              <UIFormControlBox>
                                <UICheckbox
                                  label={<UITypography variant={'Oxygen700'} title={'Abilita prima visita'} size={'12px'} />}
                                  checked={values?.first_visit_active}
                                  onChange={(event) => setFieldValue('first_visit_active', event.target.checked)}
                                />
                              </UIFormControlBox>
                            </Box>
                          </Box>
                          <Box display={'flex'} mt={5} bg={'rgba(200,200,200,0.2)'} p={'10px'} alignItems={'center'}>
                            <IconCalendarCog stroke={1.5} size="1.3rem" />
                            <Box ml={10}>
                              <UIFormControlBox>
                                <UICheckbox
                                  label={<UITypography variant={'Oxygen700'} title={'Prima visita gratuita'} size={'12px'} />}
                                  checked={values?.is_first_visit_free}
                                  onChange={(event) => setFieldValue('is_first_visit_free', event.target.checked)}
                                />
                              </UIFormControlBox>
                            </Box>
                          </Box>
                          {/*<Box display={'flex'} mt={5} bg={'rgba(200,200,200,0.2)'} p={'10px'} alignItems={'center'}>*/}
                          {/*  <IconCalendarCog stroke={1.5} size="1.3rem" />*/}
                          {/*  <Box ml={10}>*/}
                          {/*    <FormControl fullWidth error={Boolean(touched.first_visit_days_before && errors.first_visit_days_before)}>*/}
                          {/*      <InputLabel htmlFor="input-first_visit_days_before">Giorni di anticipo</InputLabel>*/}
                          {/*      <OutlinedInput*/}
                          {/*        id="input-first_visit_days_before"*/}
                          {/*        type="text"*/}
                          {/*        value={values.first_visit_days_before}*/}
                          {/*        name="first_visit_days_before"*/}
                          {/*        onBlur={handleBlur}*/}
                          {/*        onChange={(event) => setFieldValue('first_visit_days_before', event.target.value)}*/}
                          {/*        label="Giorni di anticipo"*/}
                          {/*      />*/}
                          {/*      {touched.first_visit_days_before && errors.first_visit_days_before && (*/}
                          {/*        <FormHelperText error id="standard-weight-helper-text-email-login">*/}
                          {/*          {errors.first_visit_days_before}*/}
                          {/*        </FormHelperText>*/}
                          {/*      )}*/}
                          {/*    </FormControl>*/}
                          {/*  </Box>*/}
                          {/*</Box>*/}
                          {/*<Box display={'flex'} mt={5} bg={'rgba(200,200,200,0.2)'} p={'10px'} alignItems={'center'}>*/}
                          {/*  <IconCalendarCog stroke={1.5} size="1.3rem" />*/}
                          {/*  <Box ml={10}>*/}
                          {/*    <FormControl fullWidth error={Boolean(touched.first_visit_duration && errors.first_visit_duration)}>*/}
                          {/*      <UIInputSelect*/}
                          {/*        fullWidth={true}*/}
                          {/*        value={values?.first_visit_duration}*/}
                          {/*        onChange={(e) => setFieldValue('first_visit_duration', e.target.value)}*/}
                          {/*        options={[*/}
                          {/*          {*/}
                          {/*            label: '15 minuti',*/}
                          {/*            value: 15*/}
                          {/*          },*/}
                          {/*          {*/}
                          {/*            label: '30 minuti',*/}
                          {/*            value: 30*/}
                          {/*          },*/}
                          {/*          {*/}
                          {/*            label: '60 minuti',*/}
                          {/*            value: 60*/}
                          {/*          }*/}
                          {/*        ]}*/}
                          {/*      />*/}
                          {/*      {touched.first_visit_duration && errors.first_visit_duration && (*/}
                          {/*        <FormHelperText error id="standard-weight-helper-text-email-login">*/}
                          {/*          {errors.first_visit_duration}*/}
                          {/*        </FormHelperText>*/}
                          {/*      )}*/}
                          {/*    </FormControl>*/}
                          {/*  </Box>*/}
                          {/*</Box>*/}
                          {/*<Box display={'flex'} mt={5} bg={'rgba(200,200,200,0.2)'} p={'10px'} alignItems={'center'}>*/}
                          {/*  <IconCalendarCog stroke={1.5} size="1.3rem" />*/}
                          {/*  <Box ml={10}>*/}
                          {/*    <FormControl fullWidth error={Boolean(touched.max_first_visit_for_day && errors.max_first_visit_for_day)}>*/}
                          {/*      <InputLabel htmlFor="input-max_first_visit_for_day">Appuntamenti per giorno</InputLabel>*/}
                          {/*      <OutlinedInput*/}
                          {/*        id="input-max_first_visit_for_day"*/}
                          {/*        type="text"*/}
                          {/*        value={values.max_first_visit_for_day}*/}
                          {/*        name="max_first_visit_for_day"*/}
                          {/*        onBlur={handleBlur}*/}
                          {/*        onChange={(event) => setFieldValue('max_first_visit_for_day', event.target.value)}*/}
                          {/*        label="Appuntamenti per giorno"*/}
                          {/*      />*/}
                          {/*      {touched.max_first_visit_for_day && errors.max_first_visit_for_day && (*/}
                          {/*        <FormHelperText error id="standard-weight-helper-text-email-login">*/}
                          {/*          {errors.max_first_visit_for_day}*/}
                          {/*        </FormHelperText>*/}
                          {/*      )}*/}
                          {/*    </FormControl>*/}
                          {/*  </Box>*/}
                          {/*</Box>*/}
                          {/*<Box display={'flex'} mt={5} bg={'rgba(200,200,200,0.2)'} p={'10px'} alignItems={'center'}>*/}
                          {/*  <IconCalendarCog stroke={1.5} size="1.3rem" />*/}
                          {/*  <Box ml={10}>*/}
                          {/*    <FormControl fullWidth error={Boolean(touched.max_first_visit_for_week && errors.max_first_visit_for_week)}>*/}
                          {/*      <InputLabel htmlFor="input-max_first_visit_for_week">Appuntamenti per settimana</InputLabel>*/}
                          {/*      <OutlinedInput*/}
                          {/*        id="input-max_first_visit_for_week"*/}
                          {/*        type="text"*/}
                          {/*        value={values.max_first_visit_for_week}*/}
                          {/*        name="max_first_visit_for_week"*/}
                          {/*        onBlur={handleBlur}*/}
                          {/*        onChange={(event) => setFieldValue('max_first_visit_for_week', event.target.value)}*/}
                          {/*        label="Appuntamenti per settimana"*/}
                          {/*      />*/}
                          {/*      {touched.max_first_visit_for_week && errors.max_first_visit_for_week && (*/}
                          {/*        <FormHelperText error id="standard-weight-helper-text-email-login">*/}
                          {/*          {errors.max_first_visit_for_week}*/}
                          {/*        </FormHelperText>*/}
                          {/*      )}*/}
                          {/*    </FormControl>*/}
                          {/*  </Box>*/}
                          {/*</Box>*/}
                          {/*<Box display={'flex'} mt={5} bg={'rgba(200,200,200,0.2)'} p={'10px'} alignItems={'center'}>*/}
                          {/*  <IconCalendarCog stroke={1.5} size="1.3rem" />*/}
                          {/*  <Box ml={10}>*/}
                          {/*    <FormControl fullWidth error={Boolean(touched.max_first_visit_for_month && errors.max_first_visit_for_month)}>*/}
                          {/*      <InputLabel htmlFor="input-max_first_visit_for_month">Appuntamenti per mese</InputLabel>*/}
                          {/*      <OutlinedInput*/}
                          {/*        id="input-max_first_visit_for_month"*/}
                          {/*        type="text"*/}
                          {/*        value={values.max_first_visit_for_month}*/}
                          {/*        name="max_first_visit_for_month"*/}
                          {/*        onBlur={handleBlur}*/}
                          {/*        onChange={(event) => setFieldValue('max_first_visit_for_month', event.target.value)}*/}
                          {/*        label="Appuntamenti per mese"*/}
                          {/*      />*/}
                          {/*      {touched.max_first_visit_for_month && errors.max_first_visit_for_month && (*/}
                          {/*        <FormHelperText error id="standard-weight-helper-text-email-login">*/}
                          {/*          {errors.max_first_visit_for_month}*/}
                          {/*        </FormHelperText>*/}
                          {/*      )}*/}
                          {/*    </FormControl>*/}
                          {/*  </Box>*/}
                          {/*</Box>*/}
                        </>
                      )}
                      <Box
                        className={'bottom_buttons'}
                        h={'50px'}
                        w={'100%'}
                        display={'flex'}
                        justifyContent={'center'}
                        alignItems={'center'}
                        px={20}
                      >
                        <Button variant={'contained'} color={'success'} type={'submit'}>
                          <IconCheck stroke={1.5} size="1rem" />
                        </Button>
                      </Box>
                    </Box>
                    <Divider />
                  </Box>
                </Box>
              )}
            </form>
          )}
        </Formik>
      </>
    </Box>
  );
};
export default ProfileView;
